import * as React from 'react';

export function useHasSwitcheroo() {
  return true;
}

export const LazyNewMusicSubmission = React.lazy(() =>
  import(
    /* webpackChunkName: "playlist-submission" */ './NewMusicSubmissionRouter'
  ).then(m => ({
    default: m.NewMusicSubmissionRouter,
  })),
);
